export function getBaseHref(): string {
    let result: string = null;
    let base = document.getElementsByTagName("base");
    if (base[0]) result = (base[0]).getAttribute("href");
    return result;
}


// WEBPACK FOOTER //
// ./src/angular_library/functions/get-base-href.ts